<template>
  <div>
    <v-toolbar flat class="mb-2">
      <v-btn color="primary" class="mr-10" @click="create()">{{createButtonText}}</v-btn>
      <v-text-field dense class="mr-3" hide-details solo placeholder="Enter search text" v-model="searchOptions.text"></v-text-field>
      <v-btn @click="refresh()">Search</v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headersModel.items"
      :items="dataModel.items"
      :items-per-page="pagingModel.pageSize"
      :server-items-length="pagingModel.totalItems"
      :page="pagingModel.page"
      class="elevation-1"
      @pagination="paginationChange"
    >
      <template v-slot:item.editButton="{ item }">
        <v-btn @click="edit(item)">Edit</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>

export default {
  name: 'MitDataTable',
  components: {
  },
  props: {
    createButtonText: String,
    headersModel: Object,
    dataModel: Object,
    pagingModel: Object
  },
  data: function() {
    return {
      searchOptions:{
        text:null
      }
    }
  },
  methods : {
    refresh(){
      this.$emit('mit-data-table-refresh');
    },
    create(){
      this.$emit('mit-data-table-create');
    },
    edit (item){
      this.$emit('mit-data-table-edit',item);
    },
    paginationChange(model){
      this.$emit('mit-data-table-page',model);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
